import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
const categories = ['Incident Reports', 'Training Plans', 'Equipment Readiness', 'Station Operations', 'Fire Prevention', 'Incident Reviews'];
export function Hero() {
  return <header className="hero-glow relative overflow-hidden" data-id="element-72" data-mp="4na0kq3ifu6v">
      <div className="tech-grid pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-73" data-mp="12a0it4iflorg" />
      <div className="relative mx-auto max-w-5xl px-5 pb-16 pt-8 text-center sm:pt-14" style={{
      paddingBottom: "13px"
    }} data-id="element-74" data-mp="x9uqdm4c7y8b">
        <h1 className="mx-auto max-w-3xl font-display text-[32px] font-extrabold leading-[1.08] tracking-tight text-ice sm:text-5xl lg:text-[58px]" data-id="element-75" data-mp="sa9rtct2xrw4">
          Generate professional fire service documents in <span className="text-crimson" data-id="element-76" data-mp="3d2l9jc5qb50p">minutes</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-steel sm:text-lg" data-id="element-77" data-mp="382p6pg8rpjmq">
          The solution to help reduce 80% repetitive paperwork with practical, ready-to-adapt AI frameworks
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-6 w-full max-w-3xl" data-id="element-78" data-mp="3o7vj9hzbpjw8">
          <img src="https://cdn.magicpatterns.com/uploads/29ZSE53jRJXUwQVRALQ2hi/Kit_de_IA_para_Bomberos.webp" alt="The 100+ AI Prompts for Firefighters™ — 6-Volume Visual System + 4 Professional Bonuses" width={1536} height={1024} sizes="(min-width: 768px) 720px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[720px] object-contain drop-shadow-[0_30px_40px_rgba(0,0,0,0.55)]" data-id="element-79" data-mp="3ebisosz2rm5p" />
        </motion.div>

        <div className="mt-6" data-id="element-80" data-mp="2hix1o3uhwnq4">
          <p className="font-display text-[22px] font-extrabold leading-tight tracking-tight text-ice sm:text-[32px]" style={{
          fontSize: "14px"
        }} data-id="element-81" data-mp="2hjypl8wm14p9">
            THE 100+ AI PROMPTS FOR FIREFIGHTERS™
          </p>
          <p className="mt-2 text-sm font-semibold text-amber sm:text-base" data-id="element-82" data-mp="s3ur9xru3ab5">
            6-Volume Visual System + 4 Professional Bonuses
          </p>
          <p className="mt-2 text-xs font-medium text-steel sm:text-sm" data-id="element-83" data-mp="id9soac5u5s8">
            The SIGMA SMART™ Method · ⭐ 4.9 (+400 Officers Satisfied) · ⚡ Instant Access
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-84" data-mp="1b15pdf1qbxp0">
          <CTAButton href="#pricing" data-id="element-85" data-mp="1ayjh1d70le5q">SEE THE 100+ AI PROMPTS FOR FIREFIGHTERS NOW</CTAButton>

          <p className="mx-auto mt-8 max-w-2xl text-[15px] leading-relaxed text-steel sm:text-lg" data-id="element-86" data-mp="15zztx9gopwbs">
            <span className="font-bold text-ice" data-id="element-87" data-mp="114ki0n28mai0">THE PRACTICAL AI COMMAND SYSTEM FOR 2026.</span> Designed for Career
            Firefighters, Volunteer Firefighters, Fire Officers, Training Instructors, and Fire Service
            Professionals who need a more organized way to prepare documentation, plan training, track
            equipment, and manage everyday station tasks.
          </p>

          <h2 className="mx-auto mt-5 max-w-2xl text-[15px] font-semibold leading-relaxed text-ice sm:text-lg" data-id="element-88" data-mp="1x7871tlc81wr">
            {categories.map((c, i) => <React.Fragment key={c} data-id="element-89" data-mp="269hgsh8s7r93" data-mpi={i}>
                {i > 0 && <span className="mx-2 text-crimson" aria-hidden="true" data-id="element-90" data-mp="267wicgjcjo5y">·</span>}
                <span className="whitespace-nowrap" data-id="element-91" data-mp="2b2ahmu14qffw">{c}</span>
              </React.Fragment>)}
          </h2>

          <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-92" data-mp="2fzarzh50i4ct">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-charcoal/80 px-3.5 py-1.5 text-xs font-medium text-ice/85" data-id="element-93" data-mp="2p0h83p3r1d5j">
                <Icon className="h-3.5 w-3.5 text-rescue" aria-hidden="true" data-id="element-94" data-mp="2tysf7s2nt9k2" />
                {label}
              </li>)}
          </ul>

          <p className="mt-5 text-sm font-medium text-steel" data-id="element-95" data-mp="zlaq40mlw4mx">- Everything you need in one single vault -</p>
        </div>

        <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-crimson/40 bg-crimson/10 px-4 py-1.5 text-xs font-bold text-crimson-soft" data-id="element-96" data-mp="4akwoxpqsifg">
          🔥 Limited Time Offer · Introductory Price: $27
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-steel" data-id="element-97" data-mp="e8scvec7iwge">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-98" data-mp="9b8m5eybor7k" />
          25 firefighters are viewing this fire service toolkit right now
        </p>
      </div>
    </header>;
}